import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import SectionCard from '@Guidelines/Component/SectionCard';
import * as React from 'react';
import { InputText, TextArea } from '@verclam/ui-kit';

/** Name and description of the group. */
const GroupIdentitySection: React.FC = () => {
	const { draft, setDraft } = useWorkflowDraft();

	const handleLabelChange = React.useCallback(
		(value: string) => {
			setDraft((current) => current.setLabel(value));
		},
		[setDraft],
	);

	const handleDescriptionChange = React.useCallback(
		(value: string) => {
			setDraft((current) => current.setDescription(value));
		},
		[setDraft],
	);

	return (
		<SectionCard title="Nom et description">
			<InputText
				name="label"
				label="Nom"
				required
				value={draft.label}
				onChange={handleLabelChange}
				errorMessage={draft.getValidationMessage('label')}
				isFormFieldValid={draft.isValid('label')}
			/>
			<TextArea
				name="description"
				label="Description"
				subLabel="Affichée au professionnel au moment de choisir un groupe."
				rows={2}
				value={draft.description}
				onChange={handleDescriptionChange}
			/>
		</SectionCard>
	);
};

export default GroupIdentitySection;
